import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { createAssistant } from 'api/assistants';
import { getModels } from 'api/models';
import TextInput from 'components/Form/TextInput';
import SelectInput from 'components/Form/SelectInput';
import TextareaInput from 'components/Form/TextareaInput';
import { getGpts } from 'api/gpts';

export default function Create() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [loadedImage, setLoadedImage] = useState(null);
    const cache = useQueryClient();
    const navigate = useNavigate();

    const { data: modelsData } = useQuery({
        queryKey: ['models'],
        queryFn: async () => await getModels({}),
    });

    const modelOptions = modelsData
        ?.filter(m => m.enabled && m.type === 'model')
        ?.map(m => ({ value: m._id, label: m.model })) || [];

    const { mutate: create } = useMutation({
        mutationKey: ['createAssistant'],
        mutationFn: createAssistant,
        onSuccess: (data) => {
            cache.invalidateQueries(['assistants']);
            return navigate(`/assistants/${data.data._id}/edit`);
        },
        onError: (error) => {
            console.error("Error creating conversation:", error);
        }
    });

    function onChangeImageHandler(e) {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLoadedImage({ file: file, image: reader.result });
            };
            reader.readAsDataURL(file);
        }
    }

    function onSubmitHandler(formData) {
        const data = Object.fromEntries(formData);
        create({ data });
    }
    
    useQuery({
        queryKey: ['gpts'],
        queryFn: async () => await getGpts({}),
        success: (data) => {
            console.log("Fetched GPTs:", data);
        }
    })
    

    const publicOptions = [
        { value: true, label: 'Sì' },
        { value: false, label: 'No' }
    ];

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] overflow-y-auto ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='pb-8 pt-20 md:pt-14'>
                        <p className='text-3xl'>Crea nuovo assistente</p>
                    </div>

                    <div className='flex items-start gap-8 pt-5'>
                        <div className='flex-1'>
                            <form action={onSubmitHandler} className='flex flex-col gap-4'>
                                <div className='md:flex gap-5'>
                                    <TextInput
                                        label="Titolo"
                                        name="name"
                                        placeholder="Titolo"
                                    />
                                    <SelectInput
                                        label="Modello"
                                        name="model"
                                        options={modelOptions}
                                    />
                                </div>

                                <TextInput
                                    label="Descrizione"
                                    name="description"
                                    placeholder="Descrizione"
                                />

                                <TextareaInput
                                    label="Istruzioni"
                                    name="instructions"
                                    placeholder="Istruzioni"
                                />

                                <div className='md:flex gap-5'>
                                    <TextInput
                                        label="Baseurl"
                                        name="baseurl"
                                        placeholder="Baseurl"
                                    />
                                    <TextInput
                                        label="apiKey"
                                        name="apiKey"
                                        placeholder="apiKey"
                                    />
                                </div>
                                <div className='md:flex gap-5'>
                                    <SelectInput
                                        label="Assistente Pubblico"
                                        name="public"
                                        placeholder="Pubblico"
                                        options={publicOptions}
                                        defaultValue={false}
                                    />
                                </div>

                                <div className='flex justify-end'>
                                    <button type="submit" className='mt-6 bg-greydark hover:bg-black text-white text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Salva modifiche</button>
                                </div>
                            </form>
                        </div>

                        <div className='w-[260px] px-6 py-12 bg-verylight border border-black/6 rounded-sm flex flex-col items-center justify-center'>
                            <div className='relative'>
                                <div className='w-28 h-28 bg-white border border-black/6 bg-cover bg-center rounded-full mb-4' style={{ backgroundImage: `url(${loadedImage?.image})` }} />

                                <div className='absolute w-7 h-7 bg-greydark rounded-full absolute top-1 right-1 flex items-center justify-center hover:bg-black cursor-pointer transition-colors duration-200'>
                                    <input type="file" className='absolute appearance-none top-0 left-0 bottom-0 right-0 opacity-0' onChange={(e) => onChangeImageHandler(e)} />
                                    <PencilSimpleIcon size={17} weight="bold" className='text-white m-1' />
                                </div>
                            </div>
                            <p className='text-lg mb-2'>Carica immagine</p>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
